function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import arrayMove from 'array-move';
import ArrayFieldSortableList from "./ArrayFieldSortableList";

class ArrayFieldSortable extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      items: []
    });

    _defineProperty(this, "componentDidUpdate", (prevProps, prevState) => {
      if (prevProps.formData !== this.props.formData) {
        this.getItems();
      }
    });

    _defineProperty(this, "getItems", () => {
      const formData = this.props.formData;
      this.setState({
        items: formData
      });
    });

    _defineProperty(this, "onSortStart", ({
      node,
      index,
      collection,
      isKeySorting
    }, event) => {});

    _defineProperty(this, "onSortEnd", ({
      oldIndex,
      newIndex
    }) => {
      const items = this.state.items;
      const formData = arrayMove(items, oldIndex, newIndex);
      this.props.onChange(formData);
    });
  }

  componentDidMount() {
    this.getItems();
  }

  render() {
    const items = this.state.items;
    return React.createElement(ArrayFieldSortableList, _extends({}, this.props, {
      arrayProps: this.props,
      items: items,
      onSortStart: this.onSortStart,
      onSortEnd: this.onSortEnd,
      helperClass: "sortable-helper",
      hideSortableGhost: true,
      useDragHandle: true
    }));
  }

}

export default ArrayFieldSortable;